import { c as _c } from "react/compiler-runtime";
import { CountryEnum, FormInput, FormSelect, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle, getSingleCountry, useTranslation as useUiTranslation } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { mercadoPagoConnect } from 'modules/profile/payment-gateways/integrations/mercadopago/api';
import { MercadoPagoCreateIntegrationInterface, MercadoPagoIntegrationErrorsInterface } from 'modules/profile/payment-gateways/integrations/mercadopago/types';
import { getMercadoPagoHelpPageLink } from 'modules/profile/payment-gateways/integrations/mercadopago/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: MercadoPagoCreateIntegrationInterface = {
  publicKey: '',
  accessToken: '',
  country: undefined
};
const defaultErrors: MercadoPagoIntegrationErrorsInterface = {
  publicKey: '',
  accessToken: '',
  country: ''
};
export const mercadoPagoCountryData: Array<CountryEnum.Brazil | CountryEnum.Colombia | CountryEnum.Mexico | CountryEnum.Argentina | CountryEnum.Chile> = [CountryEnum.Brazil, CountryEnum.Colombia, CountryEnum.Mexico, CountryEnum.Argentina, CountryEnum.Chile];
const MercadoPagoCreateModal = () => {
  const $ = _c(47);
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    user
  } = useUser();
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t0;
  if ($[0] !== mutatePaymentIntegrations) {
    t0 = async data => {
      await fetchWithErrors(async () => {
        const response = await mercadoPagoConnect(data);
        await mutatePaymentIntegrations(data_0 => {
          if (data_0) {
            return [...data_0, response.data];
          }
        }, false);
      }, setErrors);
    };
    $[0] = mutatePaymentIntegrations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCreate = t0;
  let t1;
  if ($[2] !== user?.dashboardLocale) {
    t1 = () => mercadoPagoCountryData.map(key => ({
      id: key,
      caption: getSingleCountry(key, user?.dashboardLocale)
    }));
    $[2] = user?.dashboardLocale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const countryData = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.settings.payment_gateways.connect");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <PrimaryButton onClick={t2} className="font-bold">{t3}</PrimaryButton>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t || $[10] !== tUi) {
    t5 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.MercadoPagoAR, tUi)
    });
    $[9] = t;
    $[10] = tUi;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("dashboard.settings.payment-gateways.mercado_pag-integration");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpened(false);
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== errors || $[16] !== t) {
    t8 = {
      field: "publicKey",
      onRender: (value, onChange) => <FormInput key="mercadopago-publicKey-create" label={t("dashboard.settings.payment-gateways.api_public_key")} value={value} onChange={e_0 => onChange(e_0.target.value)} required={true} error={errors.publicKey} />
    };
    $[15] = errors;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== errors || $[19] !== t) {
    t9 = {
      field: "accessToken",
      onRender: (value_0, onChange_0) => <FormInput key="mercadopago-accessToken-create" label={t("dashboard.settings.payment-gateways.access_token")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} required={true} error={errors.accessToken} />
    };
    $[18] = errors;
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== countryData || $[22] !== errors || $[23] !== t) {
    t10 = {
      field: "country",
      onRender: (value_1, onChange_1) => <FormSelect key="mercadopago-country-create" label={t("dashboard.settings.payment-gateways.country")} data={countryData()} placeholder={t("dashboard.settings.payment-gateways.choose_country")} value={value_1} onChange={data_1 => onChange_1(data_1)} required={true} error={errors.country} />
    };
    $[21] = countryData;
    $[22] = errors;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8 || $[27] !== t9) {
    t11 = [t8, t9, t10];
    $[25] = t10;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const t12 = user?.dashboardLocale;
  let t13;
  if ($[29] !== t12) {
    t13 = getMercadoPagoHelpPageLink(t12);
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== tUi) {
    t14 = getPaymentProcessorTitle(PaymentProcessorEnum.MercadoPagoAR, tUi);
    $[31] = tUi;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <HelpCenterLink link={t13} integration={t14} />;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = ["publicKey", "accessToken", "country"];
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== onCreate || $[38] !== opened || $[39] !== t11 || $[40] !== t15 || $[41] !== t5 || $[42] !== t6) {
    t17 = <CreateModal fullCaption={t5} caption={t6} opened={opened} onClose={t7} needToast={false} defaultValues={defaultValues} creatable={t11} additionalInfo={t15} onCreate={onCreate} requiredFields={t16} />;
    $[37] = onCreate;
    $[38] = opened;
    $[39] = t11;
    $[40] = t15;
    $[41] = t5;
    $[42] = t6;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t17 || $[45] !== t4) {
    t18 = <>{t4}{t17}</>;
    $[44] = t17;
    $[45] = t4;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  return t18;
};
export default MercadoPagoCreateModal;